<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="mt-3">
          <h5>THÔNG TIN CHUNG</h5>
        </div>
        <div class="" v-if="mode == 'edit'">
          <label class="txt-right required">Trạng thái dự án</label>
          <DropdownScrollable disabled defaultValue="value" defaultLabel="label" :showClear="false" readonly placeholder="Trạng thái" cusClass="text-box m-0" width="100%" v-model="status" :options="status_data"/>
          <input class="input_tmp_validator" id="status" />
        </div>
        <div class="mt-3" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable placeholder="Chọn công ty" cusClass="text-box m-0" width="100%" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'" @scroll="emitEvent"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Tên dự án</label>
          <InputText disabled
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-3 row text-box ml-0">
          <div class="p-col-6 pl-0">
            <label class="txt-right required">Bắt đầu</label>
            <div class="p-inputgroup">
              <Calendar disabled v-model="date_start" :maxDate="date_end"  dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true"/>
            </div>
            <input class="input_tmp_validator" id="date_start" />
          </div>
          <div class="p-col-6 pr-0">
            <label class="txt-right required">Kết thúc</label>
            <div class="p-inputgroup">
              <Calendar disabled v-model="date_end" :minDate="date_start" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true"/>
            </div>
            <input class="input_tmp_validator" id="date_end" />
          </div>
        </div>
        <div class="mt-3 row text-box ml-0">
          <div class="p-col-6 pl-0">
            <label class="txt-right required">Kinh phí</label>
            <div class="p-inputgroup">
              <InputNumber disabled
                v-model="fee"
                class="input-text-box"
                placeholder="Nhập"
                suffix=" đ"/>
            </div>
            <input class="input_tmp_validator" id="fee" />
          </div>
        </div>
        <div class="mt-3">
          <label class="txt-right required">Bộ phận</label>
          <DropdownScrollable disabled
          placeholder="Chọn bộ phận"
          cusClass="text-box m-0"
          width="100%"
          :limit="department_obj.limit"
          :loading="department_obj.loading"
          v-model="department"
          :options="department_obj.items"
          :total="department_obj.total"
          @scroll="emitEventDepartment"
          @offset="changeOffsetDepartment"
          />
          <input class="input_tmp_validator" id="department" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">File đính kèm</label>
            <div class="box-images text-box"  v-if="files && files.length > 0">
              <div class="d-flex align-items-center" v-for="(item, index) in files" :key="index" >
                <div class="file-name">{{ item.name }}</div>
                <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload(index)"/>
              </div>
            </div>
        </div>
        <div class="mt-3">
          <h5>DANH SÁCH BIỆN PHÁP KIỂM SOÁT</h5>
        </div>
        <div class="mt-3">
            <DataTable :value="evaluations">
              <template #empty>
                  <div class="txt-center">Chưa có dữ liệu</div>
              </template>
              <Column field="stt" header="STT" :headerStyle="{width: '6%'}">
                <template #body="{index}">
                    {{ index+1 }}
                </template>
              </Column>
              <Column field="evaluation_form_id" header="Phiếu đánh giá" :headerStyle="{width: '18%'}">
                <template #body="{data}">
                  {{data.evaluation_form.name}}
                </template>
              </Column>
              <Column field="situation_id" header="Tình huống" :headerStyle="{width: '18%'}">
                <template #body="{data}">
                  {{data.situation.name}}
                </template>
              </Column>
              <Column field="danger_id" header="Mối nguy" :headerStyle="{width: '18%'}">
                <template #body="{data}">
                  {{data.danger.name}}
                </template>
              </Column>
              <Column field="control_measure_id" header="Biện pháp" :headerStyle="{width: '18%'}">
                <template #body="{data}">
                  {{data.control_measure.name}}
                </template>
              </Column>
              <Column field="created_at" header="Ngày tạo" :headerStyle="{width: '15%'}">
                <template #body="{data}">
                  {{data.created_at | formatDateTime}}
                </template>
              </Column>
              
          </DataTable>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      filters: {},
      name: "",
      date_start: null,
      date_end: null,
      fee: null,
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department: {},
      department_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      status: null,
      status_data: [
        { value: "NEW", label: "Mới" },
        { value: "INPROCESS", label: "Đang thực hiện" },
        { value: "PENDING", label: "Tạm hoãn" },
        { value: "DONE", label: "Kết thúc" },
      ],
      files: [],
      maxFiles: 10,
      maxFileSize: 10485760*5,
      filesDeletes: [],
      evaluations: [],
      company_id: null,
      listTypeFile: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      ],
      evaluation_form: null,
      danger: null,
      control: null,
      evaluation_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },

      danger_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },

      control_measures_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      loadKey: 0
    };
  },
  async mounted() {
    // if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
    //   await this.getListCompany();
    // }
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.name = this.model.name;
      this.company = this.model.company;
      this.status = this.status_data.filter(f => f.value == this.model.status)[0];
      this.fee = this.model.fee;
      this.date_end = new Date(this.model.date_end);
      this.date_start = new Date(this.model.date_start);
      this.evaluations = this.model.evaluations;
      this.department = this.model.department;
      if (!this.$commonFuction.isEmpty(this.model.list_files) && this.model.list_files.length > 0) {
        this.model.list_files.map( m => {
          let url = m.file.url
          let split = url.split('/')
          let fileName = split[split.length - 1]
          let obj = {'id': m.id, 'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
          this.files.push(obj);
        })
      }
    }else{
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
      }
    }
  },
  watch: {
    // async "company_id"() {
    //   if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
    //     this.company = {id: this.company_id};
    //     await this.getListDepartment();
    //   }
    // },
    // async "$store.getters.company_id"() {
    //   if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
    //     this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    //     this.company = {id: this.company_id};
    //     await this.getListDepartment();
    //   }
    // },
    // async "company"() {
    //   await this.getListDepartment();
    //   await this.getListEvaluation();
    //   if (this.mode == "edit" && this.loadKey == 0) {
    //     this.loadKey++;
    //   } else {
    //     this.department = null;
    //   }
    //   this.evaluation_form = null;
    // },
    // async "evaluation_form"() {
    //   await this.getListDanger();
    //   this.danger = null;
    // },
    // async "danger"() {
    //   await this.getListControl();
    //   this.control = null;
    // }
  },
  methods: {
    async validateDataControl() {
      this.validationErrors = {};

      let evaluation_form_add = document.getElementById("evaluation_form_id");
      if (
        this.evaluation_form == undefined ||
        this.evaluation_form == null ||
        this.evaluation_form == "" ||
        this.$commonFuction.isEmptyObject(this.evaluation_form)
      ) {
        evaluation_form_add.setCustomValidity("Phiếu đánh giá không được để trống!");
      } else {
        evaluation_form_add.setCustomValidity("");
      }

      let danger = document.getElementById("danger");
      if (
        this.danger == undefined ||
        this.danger == null ||
        this.danger == "" ||
        this.$commonFuction.isEmptyObject(this.danger)
      ) {
        danger.setCustomValidity("Mối nguy không được để trống!");
      } else {
        danger.setCustomValidity("");
      }

      let control = document.getElementById("control");
      if (
        this.control == undefined ||
        this.control == null ||
        this.control == "" ||
        this.$commonFuction.isEmptyObject(this.control)
      ) {
        control.setCustomValidity("Biện pháp kiểm soát không được để trống!");
      } else {
        control.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action_control");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async viewControl(data) {
      window.open(`/admin/control_measures/edit/${data.control_measure.id}?company_id=${this.company?.id}`);
    },
    async removeControl(data, index) {
      console.log(data);
      this.evaluations.splice(index, 1);
    },
    async emitEventControl(keyword) {
      this.$delete(this.control_measures_obj.filters, 'name');
      if (keyword) {
        this.control_measures_obj.filters.name = keyword;
      }
      await this.getListControl();
    },
    async changeOffsetControl(value) {
      this.control_measures_obj.offset = value;
      // await this.getListControl();
    },
    async getListControl() {
      if (this.$commonFuction.isEmptyObject(this.company) || this.$commonFuction.isEmptyObject(this.evaluation_form) || this.$commonFuction.isEmptyObject(this.danger)) {
        this.control_measures_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      this.control_measures_obj.filters.evaluation_form_id = this.evaluation_form?.id;
      this.control_measures_obj.filters.danger_id = this.danger?.danger_id;
      this.control_measures_obj.filters.control_measures_exist = this.evaluations.map(m => {
        return m.control_measure.id;
      });
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && this.danger?.danger_id && this.evaluation_form?.id){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.control_measures_obj.loading = true;
        await ApiRepository.post("/_api/control_measures/options", {filters: this.control_measures_obj.filters, limit: 20, offset: this.control_measures_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.control_measures_obj.items.push(...res.data.data.list);
          } else {
            this.control_measures_obj.items = res.data.data.list;
          }
          this.control_measures_obj.total = res.data.data.total;
          this.control_measures_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.control_measures_obj.loading = false;
        })
      }
    },
    async emitEventDanger(keyword) {
      this.$delete(this.danger_obj.filters, 'name');
      if (keyword) {
        this.danger_obj.filters.name = keyword;
      }
      await this.getListDanger();
    },
    async changeOffsetDanger(value) {
      this.danger_obj.offset = value;
      // await this.getListDanger();
    },
    async getListDanger() {
      if (this.$commonFuction.isEmptyObject(this.company) || this.$commonFuction.isEmptyObject(this.evaluation_form)) {
        this.danger_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      this.danger_obj.filters.evaluation_form_id = this.evaluation_form?.id;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && this.evaluation_form?.id){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.danger_obj.loading = true;
        await ApiRepository.post("/_api/danger/options_by_evaluation", {filters: this.danger_obj.filters, limit: 20, offset: this.danger_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.danger_obj.items.push(...res.data.data.list);
          } else {
            this.danger_obj.items = res.data.data.list;
          }
          this.danger_obj.total = res.data.data.total;
          this.danger_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.danger_obj.loading = false;
        })
      }
    },
    async emitEventEvaluation(keyword) {
      this.$delete(this.evaluation_obj.filters, 'name');
      if (keyword) {
        this.evaluation_obj.filters.name = keyword;
      }
      await this.getListEvaluation();
    },
    async changeOffsetEvaluation(value) {
      this.evaluation_obj.offset = value;
      // await this.getListEvaluation();
    },
    async getListEvaluation() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.evaluation_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/evaluation_form/options", {filters: this.evaluation_obj.filters, limit: 20, offset: this.evaluation_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.evaluation_obj.items.push(...res.data.data.list);
          } else {
            this.evaluation_obj.items = res.data.data.list;
          }
          this.evaluation_obj.total = res.data.data.total;
          this.evaluation_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.evaluation_obj.loading = false;
        })
      }
    },
    async addEvaluation() {
      // if (!this.evaluation_form?.id || !this.danger?.id || !this.control?.id) {
      //   alert("Vui lòng nhập đủ thông tin!");
      //   return;
      // }
      if (await this.validateDataControl()) {
        return;
      }
      this.evaluations.push({
        id: `evaluation-${this.$commonFuction.generateUUID()}`,
        danger: {
          id: this.danger.danger_id,
          name: this.danger.danger_name
        },
        situation: {
          id: this.danger.situation_id,
          name: this.danger.situation_name
        },
        evaluation_form: {
          id: this.evaluation_form.id,
          name: this.evaluation_form.name
        },
        control_measure: {
          id: this.control.id,
          name: this.control.name
        },
        created_at: new Date()
      }),
      this.evaluation_form = null;
    },
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.company_obj.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: 20, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.company_obj.items.push(...res.data.data.company);
          } else {
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      console.log(keyword);
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.department_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.department_obj.loading = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.count;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      if (this.mode == "edit") {
        let status = document.getElementById("status");
        if (
          this.$commonFuction.isEmptyObject(this.status) ||
          this.$commonFuction.isEmpty(this.status)
        ) {
          status.setCustomValidity("Trạng thái không được để trống!");
        } else {
          status.setCustomValidity("");
        }
      }

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Tên dự án không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên dự án không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }

      let date_start_add = document.getElementById("date_start");
      if (
        this.date_start == undefined ||
        this.date_start == null ||
        this.date_start == ""
      ) {
        date_start_add.setCustomValidity("Ngày bắt đầu không được để trống!");
      } else if (this.date_start > this.date_end) {
        date_start_add.setCustomValidity("Ngày bắt đầu phải nhỏ hơn ngày kết thúc!");
      } else {
        date_start_add.setCustomValidity("");
      }

      let date_end_add = document.getElementById("date_end");
      if (
        this.date_end == undefined ||
        this.date_end == null ||
        this.date_end == ""
      ) {
        date_end_add.setCustomValidity("Ngày kết thúc không được để trống!");
      } else if (this.date_start > this.date_end) {
        date_end_add.setCustomValidity("Ngày kết thúc phải lớn hơn ngày bắt đầu!");
      } else {
        date_end_add.setCustomValidity("");
      }

      let fee = document.getElementById("fee");
      if (
        this.fee == undefined ||
        this.fee == null ||
        this.fee == ""
      ) {
        fee.setCustomValidity("Kinh phí không được để trống!");
      } else if (this.fee <= 0) {
        fee.setCustomValidity("Kinh phí phải là số nguyên dương!");
      } else {
        fee.setCustomValidity("");
      }

      let department = document.getElementById("department");
      if (
        this.department == undefined ||
        this.department == null ||
        this.department == "" ||
        this.$commonFuction.isEmptyObject(this.department)
      ) {
        department.setCustomValidity("Bộ phận không được để trống!");
      } else {
        department.setCustomValidity("");
      }

      let files = document.getElementById("files");
      if (
        this.files.length <= 0
      ) {
        files.setCustomValidity("File đính kèm không được để trống!");
      } else {
        files.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        files: this.files,
        company: this.company,
        department: this.department,
        date_start: this.date_start,
        date_end: this.date_end,
        fee: this.fee,
        evaluations: this.evaluations,
        filesDeletes:this.filesDeletes
      };
      if (this.mode == "edit") {
        params.status = this.status?.value;
      }
      console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
    isImage(file) {
      // return /^image\//.test(file.type);
      return this.listTypeFile.includes(file.type);
    },
    async onFileDownload(index) {
      let file = this.files[index];
      window.open(file.objectURL);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 10) {
          event.target.value = "";
          alert("Chỉ được upload tối đa 10 ảnh");
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = "";
            alert(
              "Please upload the image file in the following format: docx, doc, xlsx, pptx, pdf"
            );
            return;
          }
        }
        if (files.length + this.files.length > this.maxFiles) {
          event.target.value = "";
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " files");
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // if(this.isImage(file)){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                arrTemp.push(file);
              }
              if (file.size > this.maxFileSize) arrFiles.push(file);
            // }
          }

          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            return;
          } else {
            // if (this.files.length > 0 && this.files[0].file === "") {
            //   this.filesDeletes.push(this.files[0]);
            // }
            // this.files = [];
            this.files = this.files.concat.apply(this.files, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let file = this.files[index];
      this.files.splice(index, 1);
      if (file.file === "" && file.id) this.filesDeletes.push(file.id);
    },
  },
  filters: {
    formatDateTime: function (value) {
      var time_zone_local = moment.tz.guess(true);
      var newValue = moment.tz(value, time_zone_local).format("DD/MM/yyyy HH:mm");
      return newValue;
    }
  }
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
</style>
